import React, { Component } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import about1 from "../assets/images/pivas_bgc.jpg";

export default class AboutTwo extends Component {
  constructor() {
    super();
    this.state = {
      startCounter: false
    };
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ startCounter: true });
    }
  };

  render() {
    return (
      <section className="about-two">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="about-two__content">
                <div className="block-title text-left">
                  <h2 className="block-title__title">
                    欢迎来到 <br />
                    卫捷医药科技！！
                  </h2>
                </div>
                <p className="about-two__text">
                  苏州卫捷医药科技有限公司专注于医院自动化领域软硬件系统开发的高科技企业,致力于将全球最新的通信与控制自动化技术应用于中国医疗行业。公司将最先进的信息智能技术应用于临床管理，荣获国家发明专利近百项，实现人类医疗和健康的信息化和智能化。
                </p>
                <div className="about-two__single-wrap">
                  <div className="about-two__single">
                    <div className="about-two__single-icon">
                      <i className="kipso-icon-professor"></i>
                    </div>
                    <div className="about-two__single-content">
                      <p className="about-two__single-text">
                        PIVAS解决方案<br /> 引领者
                      </p>
                    </div>
                  </div>
                  <div className="about-two__single">
                    <div className="about-two__single-icon">
                      <i className="kipso-icon-knowledge"></i>
                    </div>
                    <div className="about-two__single-content">
                      <p className="about-two__single-text">
                        新型智能医疗<br />标杆企业
                      </p>
                    </div>
                  </div>
                </div>
                {/* <a href="#none" className="thm-btn">
                  阅读更多
                </a> */}
              </div>
            </div>
            <div className="col-xl-6 d-flex justify-content-xl-end justify-content-sm-center">
              <div className="">
                {/* <span className="about-two__image-dots"></span> */}
                <img src={about1} alt="" style={{ width: "520px", height: "500px" }} />
                <div className="about-two__count">
                  <div className="about-two__count-text">
                    合作医院
                    <span className="counter">
                      <VisibilitySensor
                        onChange={this.onVisibilityChange}
                        offset={{ top: 10 }}
                        delayedCall
                      >
                        <CountUp end={this.state.startCounter ? 700 : 0} />
                      </VisibilitySensor>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
